// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { hasError } from '../../utils/formatError';
import { WALLET_RULE_KIND } from '../../constants/walletRuleKind';

/**
 * Wallet rules: the rule a gateway names for its payins or payouts. Core evaluates
 * the filterRule for every candidate wallet when it picks one; the cabinet refuses
 * one that does not compile for the rule's kind (422 `WALLET_RULE_INVALID: …`),
 * shown in the dialog as any other refusal. The orderRule decides which of the
 * admitted wallets is tried first: picked as columns (DialogWalletOrderField),
 * compiled on save as the filter is.
 */
export default class WalletRulesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicWalletRules';
        this.Server = this.props.context.getState().server.publicWalletRules;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            {
                id: 'kind', required: true,
                label: 'kind',
                alignRight: false,
                cell: 'Items',
                items: WALLET_RULE_KIND,
                displayGrid: true
            },
            // The BigText editor plus the language's help: its syntax and the
            // variables the API lists (loaded below). Blank keeps every wallet.
            {
                id: 'filterRule',
                label: 'filterRule',
                alignRight: false,
                cell: 'WalletRule',
                helperText: 'walletRuleFilter',
                displayGrid: true
            },
            {
                id: 'orderRule',
                label: 'orderRule',
                hint: 'helperTexts.walletRuleOrder',
                alignRight: false,
                cell: 'WalletOrder',
                helperText: 'walletRuleOrder',
                displayGrid: true
            },
            { id: 'isArchived', label: 'isArchived', alignRight: false, cell: 'Boolean', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    async componentDidMount() {
        this.loadVariables();
        await super.componentDidMount();
    }

    /**
     * The variables a rule may read, once per session, into the store, where the
     * filterRule editor's help reads them (DialogWalletRuleField). `false` when they
     * could not be loaded, so the help says so and the next visit tries again.
     */
    loadVariables = async () => {
        const { context } = this.props;
        if (context.getState().walletRuleVariables) return;
        try {
            const result = await this.Server.variables();
            const ok = !hasError(result) && Array.isArray(result.data);
            context.update({ walletRuleVariables: ok ? result.data : false });
        } catch (error) {
            console.error('Wallet rule variables could not be loaded:', error);
            context.update({ walletRuleVariables: false });
        }
    };
}
